export function generateUuid(): string {
  try {
    const g = globalThis as typeof globalThis & { crypto?: Crypto };
    const cryptoRef: Crypto | undefined =
      g.crypto ?? (typeof window !== 'undefined' ? window.crypto : undefined);
    if (cryptoRef && typeof cryptoRef.randomUUID === 'function') {
      return cryptoRef.randomUUID();
    }
    if (cryptoRef && typeof cryptoRef.getRandomValues === 'function') {
      const bytes = new Uint8Array(16);
      cryptoRef.getRandomValues(bytes);
      // Per RFC 4122 v4
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;
      const toHex = (n: number) => n.toString(16).padStart(2, '0');
      const hex = Array.from(bytes, toHex).join('');
      return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    }
  } catch {
    // Ignore and fall back
  }
  // Non-crypto fallback
  const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .slice(1);
  return `${Date.now()}-${s4()}${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}

/**
 * Correlation-style id: `prefix_timestamp_uuid`. Suitable for error boundaries and support
 * references; not for auth secrets. The UUID segment uses {@link generateUuid} (Web Crypto
 * when available), not `Math.random`.
 */
export function generateTempId(prefix: string = 'temp'): string {
  return `${prefix}_${Date.now()}_${generateUuid()}`;
}
